import React from 'react'
import Header from './Header'
import { Buttons } from '../Buttons'
import { submitContactEmail } from '../../contact'

const Touch = () => {
  return (
    <div className="w-full h-full bg-black px-[4rem] py-[5rem] flex justify-center items-cetner gap-[4rem] flex-wrap">
      <Header
        title={"Get In Touch"}
        subtitle={"We’re Here to Help You Manage Your Property"}
        description={
          "Whether you own a single rental home or a commercial property portfolio in the San Francisco & Bay Area, our licensed and experienced team is ready to provide expert property management solutions. Contact us today to discuss your goals, schedule a consultation, or request more information about our services."
        }
      />
       <div className="w-full flex justify-center relative">
           <form className="w-full max-w-4xl mx-auto space-y-6 font-outfit" onSubmit={(event) => submitContactEmail(event, 'Homepage property consultation inquiry')}>

              {/* 2 Column Grid for Inputs */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[2rem]">
                {[
                  { label: 'First Name', name: 'firstName', autoComplete: 'given-name' },
                  { label: 'Last Name', name: 'lastName', autoComplete: 'family-name' },
                  { label: 'Email Address', name: 'email', autoComplete: 'email' },
                  { label: 'Phone Number', name: 'phone', autoComplete: 'tel' },
                ].map((field, idx) => (
                  <div
                    key={field.name}
                    data-aos="fade-up"
                    data-aos-delay={100 + idx * 100} // stagger inputs
                  >
                    <label htmlFor={`home-contact-${field.name}`} className="block mb-1 text-[20px] text-gradient font-bold font-Quicksand">{field.label}</label>
                    <input
                      id={`home-contact-${field.name}`}
                      name={field.name}
                      type={field.name === 'email' ? 'email' : field.name === 'phone' ? 'tel' : 'text'}
                      autoComplete={field.autoComplete}
                      required={field.name !== 'phone'}
                      placeholder={`Enter Your ${field.label} ...`}
                      className="w-full p-3 rounded-lg border border-[#262626] bg-[#1A1A1A] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#262626]"
                    />
                  </div>
                ))}
              </div>

              {/* Message */}
              <div data-aos="fade-up" data-aos-delay="600" className='mt-[2rem]'>
                <label htmlFor="home-contact-message" className="block mb-1 text-[20px] font-bold font-Quicksand text-gradient ">Message</label>
                <textarea
                  id="home-contact-message"
                  name="message"
                  required
                  rows="5"
                  placeholder="Enter Your Message ..."
                  className="w-full p-3 rounded-lg border border-[#262626] bg-[#1A1A1A] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#262626]"
                ></textarea>
              </div>

          

              <div data-aos="zoom-in" data-aos-delay="800">
                <Buttons title={"Submit"} type="submit" />
              </div>

            </form>
       </div>
    </div>
  )
}

export default Touch
